import * as React from "react";
import { FileUploadDataErrors } from "../../TypeScript/interfaces";
import { validateUploadInformations } from "../Validations/validations";
import { useFileUploadInfoData } from "../Contexts/fileUploadInfoProvider";
import { FileUploadData } from "../../TypeScript/interfaces";
import { AxiosResponse, AxiosError } from "axios";
import api from "../../axios/axios";
import { dbValidations } from "../Validations/validations";

interface Props {
  setSelectedPage: React.Dispatch<React.SetStateAction<string>>;
  selectedPage: string;
  setSelectedCountry: React.Dispatch<React.SetStateAction<string>>;
  country: string;
  setSelectedOption: React.Dispatch<React.SetStateAction<string>>;
  selectedOption: string;
  agree?: boolean;
  setErrors?: React.Dispatch<React.SetStateAction<FileUploadDataErrors>>;
  setWarnings?: React.Dispatch<React.SetStateAction<string[]>>;
}

const ButtonNavigation: React.FC<Props> = (props) => {
  const {
    setSelectedPage,
    setSelectedCountry,
    setSelectedOption,
    selectedOption,
    selectedPage,
    country,
    agree,
    setErrors,
    setWarnings,
  } = props;

  const [disableButtons, setDisableButtons] = React.useState(false);
  const { fileUploadData, setUploadData } = useFileUploadInfoData();

  const sendData = (fileUploadData: FileUploadData) => {
    api
      .post("/bol-gui/v1/bol/bolUpload", fileUploadData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response: AxiosResponse) => {
        setUploadData({
          ...fileUploadData,
          returnedReferenceCode: response.data.referenceCode,
          returnedTimeStamp: response.data.timeStamp,
          returnedError: response.data.error,
        });
        // if error does not contains value then no errror
        if (!response.data.error) { 
          setSelectedPage("FileUploadConfirmation");
          console.log(`Request Result: ${JSON.stringify(response.data)}`);
          // if error contains value desc then errror
        } else if (response.data.error) { 
          setUploadData({
            ...fileUploadData,
            returnedReferenceCode: response.data.referenceCode,
            returnedTimeStamp: response.data.timeStamp,
            returnedError: response.data.error,
          });
          setSelectedPage("ErrorPage");
        }
        console.log(
          response.data.referenceCode + " " + response.data.referenceCode
        );
        setDisableButtons((prevState) => !prevState);
      })
      .catch((error: AxiosError) => {
        console.log(JSON.stringify(error, null, 2));
        if (error.response?.data === "user not logged") {          
          setUploadData({returnedError: error.response?.data});          
          setSelectedPage("LoginScreen");
        } else {
          setUploadData({
            ...fileUploadData,
            returnedError: "UnexpectedError",
          });
          setSelectedPage("ErrorPage");
        }
      });
  };

  const handleButtonClick = (clickedButton: string) => {
    switch (clickedButton) {
      case "cancel":
        setSelectedPage("MarketSelection");
        setSelectedCountry("");
        setSelectedOption("");
        setUploadData({});
        break;
      case "back":
        if (selectedPage === "GermanOptions") {
          setSelectedPage("MarketSelection");
          setSelectedCountry("");
          setSelectedOption("");
          setUploadData({});
        } else if (
          selectedPage === "Acknowledgement" &&
          country === "Germany"
        ) {
          setSelectedPage("GermanOptions");
        } else if (selectedPage === "FileUploadVerification") {
          setSelectedPage("FileUploadInfo");
        } else if (selectedPage === "Acknowledgement") {
          setSelectedPage("MarketSelection");
          setSelectedCountry("");
          setSelectedOption("");
        } else if (selectedPage === "FileUploadInfo") {
          setSelectedPage("Acknowledgement");
          setUploadData({});
        } else if (selectedPage === "FileUploadVerification") {
          setSelectedPage("FileUploadInfo");
        }
        break;
      case "continue":
        if (selectedPage === "GermanOptions" && selectedOption) {
          setSelectedPage("Acknowledgement");
        } else if (selectedPage === "Acknowledgement" && agree) {
          setSelectedPage("FileUploadInfo");
        } else if (selectedPage === "FileUploadInfo") {
          const warnings: string[] = [];
          const errors = validateUploadInformations(fileUploadData, country, warnings);
          if (errors.validSetup) {                  
            const uploadData = {...fileUploadData};

            setDisableButtons((prevState) => !prevState);
            dbValidations(uploadData, errors, warnings).then(() => {
              if (uploadData.returnedError === "UnexpectedError") {
                setUploadData({
                  ...fileUploadData,
                  returnedError: "UnexpectedError",
                });
                setSelectedPage("ErrorPage");
              } else if (uploadData.returnedError === "user not logged") {                
                setUploadData({returnedError: uploadData.returnedError});
                setSelectedPage("LoginScreen");
              } else if (errors.validSetup)  {
                setWarnings && setWarnings(warnings);
                setUploadData({
                  ...fileUploadData,
                  id: uploadData.id
                });
                setSelectedPage("FileUploadVerification");                
              } else {
                setErrors && setErrors(errors);
                setWarnings && setWarnings(warnings);
              }
              setDisableButtons((prevState) => !prevState);
            });
          } else {
            setErrors && setErrors(errors);
          }
        } else if (selectedPage === "FileUploadVerification") {
          setDisableButtons((prevState) => !prevState);
          sendData(fileUploadData);
        }
        break;
    }
  };

  return (
    <div
      style={{
        width: "100%",
        marginTop: "25px",
      }}
    >
      <div className="inline" style={{ width: "33.3%", marginTop: "10px" }}>
        <button
          className="buttonaslink"
          onClick={() => handleButtonClick("back")}
          disabled={disableButtons}
        >
          {"<"} Back
        </button>
      </div>
      <div
        className="inline"
        style={{ width: "33.3%", textAlign: "center", marginTop: "10px" }}
      >
        <button
          className="buttonaslink"
          onClick={() => handleButtonClick("cancel")}
          disabled={disableButtons}
        >
          Cancel
        </button>
      </div>
      <div
        className="inline"
        style={{ width: "33.3%", textAlign: "right", marginTop: "10px" }}
      >
        <button
          className="buttonaslink"
          onClick={() => handleButtonClick("continue")}
          disabled={disableButtons}
        >
          Continue {">"}
        </button>
      </div>
    </div>
  );
};

export default ButtonNavigation;
